export var SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
//# sourceMappingURL=enums.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/utils/esm/enums.js
// module id = 247
// module chunks = 0